



















import {Component, Vue, Prop} from 'vue-property-decorator';
import ServiceContainer from '@flashpointbv/solar-service-container';

@Component({
  name: 'product-review-item',
  components: ServiceContainer().getComponents()
})

export default class extends Vue {
  @Prop() private readonly review: object;

  private get formattedDate(): string | null {
    return this.review['created_at'] ? new Date(this.review['created_at'] * 1000).toLocaleDateString('nl-NL', {year: 'numeric', month: 'long', day: 'numeric'}) : null;
  }
}
